import {CURRENCY} from './currency';

export const LANGUAGE_LABELS = {
  'zh-TW': '繁體中文',
  'zh-CN': '简体中文',
  'en-US': 'English',
  'ja-JP': '日本語',
  'es-ES': 'Español',
  'fr-FR': 'Français',
  'de-DE': 'Deutsch',
  'it-IT': 'Italiano',
  'ko-KR': '한국어',
  'pt-PT': 'Português',
  'ru-RU': 'Русский',
  'vi-VN': 'Tiếng Việt',
  'id-ID': 'Bahasa Indonesia',
  'th-TH': 'ไทย',
  'ms-MY': 'Bahasa Melayu',
  'ar-SA': 'العربية',
  'tr-TR': 'Türkçe',
  'hi-IN': 'हिन्दी',
};

export const LANGUAGE = {
  ZH_TW: 'zh-TW',
  ZH_CN: 'zh-CN',
  EN_US: 'en-US',
  JA_JP: 'ja-JP',
  ES_ES: 'es-ES',
  FR_FR: 'fr-FR',
  DE_DE: 'de-DE',
  IT_IT: 'it-IT',
  KO_KR: 'ko-KR',
  PT_PT: 'pt-PT',
  RU_RU: 'ru-RU',
  VI_VN: 'vi-VN',
  ID_ID: 'id-ID',
  TH_TH: 'th-TH',
  MS_MY: 'ms-MY',
  AR_SA: 'ar-SA',
  TR_TR: 'tr-TR',
  HI_IN: 'hi-IN',
};

export const CURRENCY_MAPPING = {
  [LANGUAGE.ZH_TW]: CURRENCY.TWD,
  [LANGUAGE.ZH_CN]: CURRENCY.USD,
  [LANGUAGE.EN_US]: CURRENCY.USD,
  [LANGUAGE.JA_JP]: CURRENCY.JPY,
};

export default {LANGUAGE_LABELS, LANGUAGE, CURRENCY_MAPPING};
